import {
  Accordion,
  AccordionDetails,
  Divider,
  Grid,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched } from 'formik';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { ReleaseElectoralCard } from 'front-office/view-models/release-electoral-card';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import ListReasons from 'shell/components/shared/list-reasons';

interface AccordionCardData {
  values?: ReleaseElectoralCard;
  onChange: (
    key: keyof ReleaseElectoralCard,
    value: ReleaseElectoralCard[keyof ReleaseElectoralCard]
  ) => void;
  errors?: FormikErrors<ReleaseElectoralCard>;
  touched?: FormikTouched<ReleaseElectoralCard>;
}

const AccordionCardData = ({
  values,
  onChange,
  errors,
  touched,
}: AccordionCardData): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-persons-card"
        id="panel-persons-card"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>{'Dati elettorali'}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <PmiTitleDivider>Dati Elettore</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={9}>
              <PmiTextField
                label="Cognome"
                aria-label="Cognome"
                id="electoralSurname"
                fullWidth
                disabled
                value={values?.electoralSurname || ''}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={9}>
              <PmiTextField
                label="Nome"
                aria-label="Nome"
                id="electoralName"
                fullWidth
                disabled
                value={values?.electoralName || ''}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Data di nascita"
                label="Data di nascita"
                id="dateOfBirth"
                name="dateOfBirth"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.dateOfBirth || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Comune di nascita"
                label="Comune di nascita"
                id="placeOfBirth"
                name="placeOfBirth"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.placeOfBirth || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Provincia di nascita"
                label="Provincia di nascita"
                id="provinceOfBirth"
                name="provinceOfBirth"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.provinceOfBirth || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Residenza"
                label="Residenza"
                id="residenceDescription"
                name="residenceDescription"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.residenceDescription || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Provincia"
                label="Provincia"
                id="provNatPlaceResidence"
                name="provNatPlaceResidence"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.provNatPlaceResidence || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Indirizzo"
                label="Indirizzo"
                id="address"
                name="address"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.address || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Fascicolo"
                label="Fascicolo"
                id="dossier"
                name="dossier"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.dossier || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Stato Elettore"
                label="Stato Elettore"
                id="state"
                name="state"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.electorState || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Anno Iscrizione"
                label="Anno Iscrizione"
                id="inscriptionYear"
                name="inscriptionYear"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.inscriptionYear || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Sezione"
                label="Sezione"
                id="section"
                name="section"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.section || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Sede di votazione"
                label="Sede di votazione"
                id="votationAddress"
                name="votationAddress"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.sectionAddress || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Progressivo Sezione"
                label="Progressivo Sezione"
                id="sectionProgressive"
                name="sectionProgressive"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.sectionProgressive || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="N. lista generale"
                label="N. lista generale"
                id="generalListNumber"
                name="generalListNumber"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.generalListNumber || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Collegio Camera Uninominale"
                label="Collegio Camera Uninominale"
                id="roomUni"
                name="roomUni"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.roomUni || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Collegio Camera Plurinominale"
                label="Collegio Camera Plurinominale"
                id="roomPluri"
                name="roomPluri"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.roomPluri || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Collegio Senato Uninominale"
                label="Collegio Senato Uninominale"
                id="senateUni"
                name="senateUni"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.senateUni || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Collegio Senato Plurinominale"
                label="Collegio Senato Plurinominale"
                id="senatePluri"
                name="senatePluri"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.senatePluri || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Collegio Provinciale"
                label="Collegio Provinciale"
                id="senate"
                name="senate"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.province || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Municipio"
                label="Municipio"
                id="zone"
                name="zone"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.zone || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Dati Tessera Precedente</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Numero tessera precedente"
                label="Numero tessera precedente"
                id="previousCardNumber"
                name="previousCardNumber"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousCardNumber || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Rilasciata il"
                label="Rilasciata il"
                id="previousReleaseDate"
                name="previousReleaseDate"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousReleaseDate || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Motivo rilascio"
                label="Motivo rilascio"
                id="previousReleaseReason"
                name="previousReleaseReason"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousReleaseReason || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Stato Tessera"
                label="Stato Tessera"
                id="previousCardState"
                name="previousCardState"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousCardState || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Dati Tessera Nuova</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Numero tessera nuova"
                label="Numero tessera nuova *"
                id="newCardNumber"
                name="newCardNumber"
                type="text"
                fullWidth
                variant="outlined"
                inputProps={{
                  maxLength: '9',
                }}
                value={values?.newCardNumber || ''}
                onChange={(event) => onChange('newCardNumber', event.target.value)}
                error={touched?.newCardNumber && !!errors?.newCardNumber}
                helperText={errors?.newCardNumber}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Rilasciata il"
                label="Rilasciata il"
                id="newReleaseDate"
                name="newReleaseDate"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.newReleaseDate || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <ListReasons
                value={values?.newReleaseReason || ''}
                required
                error={touched?.newReleaseReason && !!errors?.newReleaseReason}
                onChange={(event: SelectChangeEvent<string>) =>
                  onChange('newReleaseReason', event.target.value)
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionCardData.displayName = 'Card data';

export default AccordionCardData;
